<template>
  <div class="login-container">
    <div class="login-container-form">
      <div class="login-container-logo">
        <img src="@/assets/logo-project.png" />
      </div>
      <div class="login-container-title">
        {{ $t('login.Release your inner lion and let it roar') }}
      </div>
      <div :class="submitError ? 'form-header h-error' : 'form-header'">
        <h3 v-if="submitError == ''">{{ $t('login.Log In') }}</h3>
        <a-alert
          v-else
          :message="submitError"
          type="error"
          show-icon
          closable
          :afterClose="
            () => {
              this.submitError = ''
            }
          "
        />
      </div>
      <a-form
        :model="form"
        @submit.prevent="handleSubmit"
        :rules="validateRules"
      >
        <a-form-item class="afi-username" name="username">
          <a-input
            id="username"
            v-model:value="form.username"
            placeholder="Lion ID"
          >
            <template v-slot:prefix>
              <svg-icon icon-class="lion-id"></svg-icon>
            </template>
          </a-input>
        </a-form-item>
        <a-form-item class="afi-password" name="password">
          <a-input
            id="password"
            autocomplete
            v-model:value="form.password"
            :type="hidepwd ? 'password' : 'text'"
            :placeholder="$t('login.Password')"
          >
            <template v-slot:prefix>
              <svg-icon icon-class="password"></svg-icon>
            </template>
            <template v-slot:suffix>
              <svg-icon
                class="btn-pwd"
                :icon-class="hidepwd ? 'eye-open' : 'eye-close'"
                @click="
                  () => {
                    this.hidepwd = !this.hidepwd
                  }
                "
              ></svg-icon>
            </template>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-checkbox v-model:checked="rembermeMark">
            {{ $t('login.Remember my information') }}
          </a-checkbox>
        </a-form-item>
        <a-form-item>
          <a-button
            :disabled="getLoginStatus()"
            type="primary"
            html-type="submit"
          >
            {{ $t('login.Log In') }}
          </a-button>
        </a-form-item>
      </a-form>
      <div class="login-container-links">
        <router-link :to="{ path: '/register' }">
          <div class="link-text">{{ $t('login.Register') }}</div>
        </router-link>
        <div class="divide">|</div>
        <router-link :to="{ path: '/resetpwd' }">
          <div class="link-text">{{ $t('login.Forget Password') }}</div>
        </router-link>
      </div>
      <div class="record-number">
        <a href="https://beian.miit.gov.cn/" target="_blank">
          沪ICP备2021007762号-3
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import { message } from 'ant-design-vue'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'Login',
    components: {},
    data() {
      return {
        submitError: '',
        form: {
          username: '',
          password: '',
        },
        validateRules: {
          username: [
            {
              required: true,
              message: this.$t('login.Please input Lion ID'),
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              message: this.$t('login.Please enter your password'),
              trigger: 'blur',
            },
          ],
        },
        rembermeMark: false,
        hidepwd: true,
        redirect: undefined,
        // dependencies: dependencies,
        // devDependencies: devDependencies,
      }
    },
    computed: {
      ...mapGetters({
        logo: 'settings/logo',
        title: 'settings/title',
        role: 'acl/role',
      }),
    },
    watch: {
      $route: {
        handler(route) {
          this.redirect = (route.query && route.query.redirect) || '/'
        },
        immediate: true,
      },
    },
    mounted() {
      const localLionId = localStorage.getItem('lionid')
      // const cachepwd = localStorage.getItem('cachepwd')
      if (localLionId) {
        this.form.username = localLionId
        this.rembermeMark = true
      }
      // if (cachepwd) {
      //   this.form.password = cachepwd
      //   this.rembermeMark = true
      // }
    },

    methods: {
      ...mapActions({
        login: 'user/login',
      }),
      getLoginStatus() {
        return this.form.password == '' || this.form.username == ''
      },
      handleRoute() {
        if (this.role.indexOf('d') >= 0) {
          return '/master'
        }
        return this.redirect === '/404' || this.redirect === '/403'
          ? '/'
          : this.redirect
      },
      async handleSubmit() {
        const res = await this.login(this.form).then(
          () => {
            if (this.rembermeMark) {
              localStorage.setItem('lionid', this.form.username)
              // localStorage.setItem('cachepwd', this.form.password)
            } else {
              localStorage.removeItem('lionid')
              localStorage.removeItem('cachepwd')
            }
            // return res
          },
          (res) => {
            if (res.code == 300 || res.code === 302) {
              // message.error('The Lion ID or password is wrong.')
              this.submitError = 'Error Lion ID or Password'
            }
            return res
          }
        )
        await this.$router.push(this.handleRoute())
      },
    },
  }
</script>
<style lang="less">
  .login-container {
    width: 100%;
    height: 100vh;
    min-width: 1440px;
    background-image: url('~@/assets/login_images/home_background.webp');
    background-size: contain;
    background-position: bottom left;
    background-repeat: no-repeat;
    background-color: #010000;
    position: relative;
    &-logo {
      width: 264px;
      height: 41px;
      margin: 0 auto;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
    &-title {
      max-width: 355px;
      font-size: 14px;
      color: #666666;
      letter-spacing: 1px;
      text-align: center;
      line-height: 20px;
      font-weight: 400;
      margin: 10px auto 15px auto;
    }
    .form-header {
      width: 368px;
      margin: 37px 0 18px 0;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      &.h-error {
        margin-top: 15px;
      }
    }

    &-form {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: 10px;
      margin-top: (-633px/2);
      width: 508px;
      height: 633px;
      padding: 60px;
      background-color: white;
      border-radius: 10px;
    }
    @media screen and (max-width: 1100px) {
      &-form {
        margin-left: (-508px/2);
      }
    }
    &-links {
      font-size: 14px;
      color: #ac7f40;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      .divide {
        margin: 0 8px;
      }
    }
    .afi-username,
    .afi-password,
    .ant-form-item {
      width: 368px;
      margin-bottom: 24px;
    }
    .ant-form-item.ant-form-item-has-error {
      margin-bottom: 8px;
    }
    .ant-form-item-explain {
      padding-left: 10px;
    }

    .ant-input {
      width: 100%;
      height: 30px;
      color: #333;
      font-size: 14px;
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 68px white inset;
        background-color: white;
      }
    }

    .ant-btn {
      width: 100%;
      height: 40px;
      border-radius: 2px;
    }
    .record-number {
      text-align: center;
      margin-top: 115px;
      a {
        font-size: 12px;
        color: #666666;
        font-size: 12px;
      }
    }
  }
  .btn-pwd {
    cursor: pointer;
  }
</style>
